export var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
export var IS_IOS = canUseDOM && /iphone|ipad|ipod/i.test(window.navigator.userAgent);


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd-mobile/es/_util/exenv.js
// module id = 363
// module chunks = 0